import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Register } from 'src/app/common-components/register/models/register';
import { getUserPrivileges } from 'src/app/privileges/privileges.selector';
import { UserPrivileges } from '../../user-details/models/user-privileges';
import { UserOrderingOptions, UserRegisterOptions } from '../models/user-register-options';
import { UserRegisterListItem } from '../models/user-register-results.model';
import { UsersFilterOption } from '../models/users-filter-option';
import * as UserRegisterActions from '../state/user-register.actions';
import { userRegisterAdapterActions, userRegisterInitialFilter } from '../state/user-register.actions';
import * as userRegisterReducer from '../state/user-register.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-user-register',
   styleUrls: ['./user-register.component.scss'],
   templateUrl: './user-register.component.html',
   standalone: false,
})
export class UserRegisterComponent
   extends Register<UserRegisterListItem, UserRegisterOptions, UserOrderingOptions>
   implements OnInit
{
   @Input() filters: UsersFilterOption[];

   @Input() showCreate: boolean;

   @Input() showAllUsersControl: boolean;

   @Input() route: string;

   entityName = 'User';

   columns: string[] = ['name', 'username', 'emailAddress', 'isLocked', 'lastLoggedIn', 'userActionsMenu'];

   columnsIncludingInactive: string[] = [
      'name',
      'username',
      'emailAddress',
      'isActive',
      'isLocked',
      'lastLoggedIn',
      'userActionsMenu',
   ];

   columns$: Observable<string[]>;

   userPrivileges$: Observable<UserPrivileges>;

   includeInactive$: Observable<boolean>;

   constructor(public store: Store) {
      super(store, userRegisterReducer.selectors, userRegisterAdapterActions);
      this.userPrivileges$ = store.pipe(select(getUserPrivileges));
      this.includeInactive$ = store.pipe(
         select(userRegisterReducer.selectQuickFilters),
         map((quickFilters) => quickFilters?.includeInactive ?? false)
      );
      this.columns$ = this.includeInactive$.pipe(
         map((includeInactive) => (includeInactive ? this.columnsIncludingInactive : this.columns))
      );
   }

   ngOnInit() {
      this.store.dispatch(userRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(UserRegisterActions.createUser());
   }
}
